export default __webpack_public_path__ + "static/media/gallery-placeholder-4x.05939e84.png";